import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const InfoSolid = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.22266 0C11.2112 0.000234499 14.4443 3.23408 14.4443 7.22266C14.4441 11.211 11.211 14.4441 7.22266 14.4443C3.23408 14.4443 0.000234502 11.2112 0 7.22266C0 3.23393 3.23393 0 7.22266 0ZM7.22168 5.75195C6.80769 5.75222 6.47266 6.0879 6.47266 6.50195V10.502C6.47274 10.9161 6.80849 11.252 7.22266 11.252C7.6366 11.2517 7.97257 10.9159 7.97266 10.502V6.50195C7.97266 6.08774 7.63589 5.75195 7.22168 5.75195ZM7.22266 2.84668C6.73945 2.84668 6.34772 3.23849 6.34766 3.72168V3.77734C6.34766 4.26059 6.73941 4.65234 7.22266 4.65234C7.70568 4.65208 8.09668 4.26043 8.09668 3.77734V3.72168C8.09661 3.23865 7.70564 2.84694 7.22266 2.84668Z" fill="currentColor" transform="translate(2.77734 2.77734)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default InfoSolid;